<template>
    <section aria-label="object-info-item">
        <div class="table-grid row">
            <div class="col">
                <img
                    v-if="data.icon?.fullpath"
                    :src="apiUrl + data.icon.fullpath"
                    width="30"
                    :alt="data.name"
                />
            </div>
            <div class="col"
                 v-html="data.name.includes('Startzeiten Tee Times') ? 'Startzeiten <br> Tee Times' : data.name"/>
            <div class="col centered-flex">
                <v-btn v-if="data.link" small variant="text" target="_blank" :href="data.link?.path">
                    <v-icon
                        small
                        color="#000000"
                        style="margin-left: 0.5rem; transform: translateY(1px)"
                    >
                        mdi-open-in-new
                    </v-icon>
                    <span style="margin-right: 0.5rem">{{ data.link?.text ? data.link.text : 'Buchung' }}</span>
                </v-btn>
                <span v-if="data.info" class="info">{{ data.info }}</span>
            </div>
        </div>
    </section>
</template>

<script setup>
import { defineProps } from 'vue'

const apiUrl = process.env.VUE_APP_API_URL

defineProps({
    data: Object,
    item: Object,
    stepsMade: {
        type: Number,
        default: 0
    }
})
</script>

<style lang="css" scoped>
.v-btn {
    text-transform: none !important;
}
</style>
